import cn from 'classnames';
import React, {FC, memo} from 'react';

import {Breadcrumb, IBreadcrumbItem} from './breadcrumb';
import {useLocationStateBreadcrumbs} from './hooks';

import './breadcrumbs.less';

interface IBreadcrumbsProps {
    breadcrumbs?: IBreadcrumbItem[];
    className?: string;
    onClickCallback?: IBreadcrumbItem['onClickCallback'];
}

export const Breadcrumbs: FC<IBreadcrumbsProps> = ({
    breadcrumbs: initialBreadcrumbs,
    className,
    onClickCallback,
}: (IBreadcrumbsProps)) => {
    const breadcrumbs = useLocationStateBreadcrumbs({breadcrumbs: initialBreadcrumbs});

    if (!breadcrumbs) return null;

    const isLast = (index: number) => index === breadcrumbs?.length - 1;

    return (breadcrumbs?.length > 0 ? (
        <div className={cn('breadcrumbs', className)}>
            {breadcrumbs?.map((breadcrumb, index) => (
                <Breadcrumb
                    key={breadcrumb.id}
                    id={breadcrumb.id}
                    name={breadcrumb.name}
                    path={breadcrumb.path}
                    extraData={breadcrumb.extraData}
                    isLast={isLast(index)}
                    onClickCallback={onClickCallback}
                />
            ))}
        </div>
    ) : null);
};

export const MemoizedBreadcrumbs = memo(Breadcrumbs);
